/**
 * 空值展示策略（上传字段 `null_ui`）。
 *
 * @core Chart 渲染、ChartSettingsV2、Dashboard 卡片共用；禁止 pages 私有路径反向被 components 引用。
 */

/** null_ui 合法取值（与保存协议一致） */
export const NullUi = {
  Break: 'break',
  Zero: '0',
  Ignore: 'ignore',
} as const;

export type TNullUiValue = (typeof NullUi)[keyof typeof NullUi];

/** 新建图表默认：折线断开 */
export const NULL_UI_DEFAULT: TNullUiValue = NullUi.Break;
